module.exports = __webpack_public_path__ + "img/liitto.bdd6a888.svg";